






























    import { Vue, Component, Prop } from "vue-property-decorator";
    import {DateTime} from "luxon";
    import {Element} from "@api/models/Element";
    import { UserProfile } from "@api/models/UserProfile";
    import { getElementOffsetWidth } from "@service/helpers/domHelper";
    import { getHowMuchWillFit } from "@service/helpers/elementSizeHelper";
    import SessionDate from "./SessionDate.vue";
    import FittedUsersList from "@share/common/users-list/FittedUsersList.vue";
    import { isShowLiveBadge, mayAttendToSession } from "@common/AgendaHelper";
    import { BackgroundViewHelper } from "@service/components/background-view/BackgroundViewHelper/BackgroundViewHelper";
	import { BackgroundViewName } from "@service/components/background-view/types/BackgroundViewName";
    import FavoritesSwitcher from "@share/common/favorites-switcher/FavoritesSwitcher.vue";
    import {isObjectInFavoritesGetter} from "@service/store/favorites/getters";
    import DateView from "@share/common/DateView.vue";

    @Component({
        components: {DateView, FavoritesSwitcher, SessionDate, FittedUsersList }
    })
    export default class SessionListItem extends Vue {

        @Prop({ required: true }) session: Element;
        @Prop({ default: false }) isFirstItem: boolean;
        @Prop({ default: false }) showFavorite: boolean;
        @Prop({default: false}) showDate: boolean;

        userIconSize = 32;
        speakersList: UserProfile[] = [];
        speakersMoreAmount = 0;
        isFavorite = false;

        mounted() {
            this.setSpeakersList();
            this.isFavorite =  this.$store.getters[isObjectInFavoritesGetter](process.env.VUE_APP_AGENDA_SCHEMA as string, this.session.id);
        }

        async goToSession() {

            if(window.innerWidth < 1024) {
                this.$emit('select')
            }
            else if(this.mayAttendToSession) {
                const confirmed = await BackgroundViewHelper.checkBroadcast(this.$store, this.session.id, BackgroundViewName.session);

                if(confirmed) {
                    this.$emit('beforeMoveToSession');
                    this.$router.push({ name: 'ViewSession', params: { ...this.$route.params, id: this.session.id} })
                }
            }
        }

        setSpeakersList() {
            const length = this.speakers?.length;
            if(length && this.hideInfo) {

                const speakersListElement = ((this.$refs['speakersList'] as Vue)?.$el as HTMLElement);
                const containerWidth = getElementOffsetWidth(speakersListElement);
                const howMuchWillFit = getHowMuchWillFit((containerWidth - this.userIconSize), this.userIconSize + 10);

                if(howMuchWillFit < length) {
                    this.speakersMoreAmount = length - howMuchWillFit;
                    this.speakersList = this.speakers.slice(0, howMuchWillFit);
                }
                else {
                    this.speakersList = this.speakers;
                }
            }
            else if(length) {
                this.speakersList = this.speakers;
            }
        }

        getIsOnlineParam(session: Element) {
            const now = DateTime.local();
            return session.beginAt <= now && session.endAt >= now;
        }

        get showIsLive() {
            return isShowLiveBadge(this.session);
        }

        get hideInfo() {
            return this.speakers.length > 1
        }

        get speakers() {
            return this.session.speakers;
        }

        get alreadyOpened() {
            return this.$route.name === "ViewSession" && this.$route.params?.id === this.session.id;
        }

        get mayAttendToSession() {
            return mayAttendToSession(this.session, (this.isAdmin || this.isSpeaker), this.alreadyOpened);
        }

        get isAdmin() {
          return this.$store.getters['isAdmin'];
        }

        get isSpeaker() {
          return this.$store.getters['isSpeaker'];
        }

        get isClosed() {
            return this.session.isClosed
        }

        get isManualControlled() {
            return this.session.isManualControlled
        }

        get isStarted() {
            return this.session.isStarted;
        }

        onFaveChanged(value: boolean) {
            this.$emit('favoritesChanged', value);
        }
    }
